const SHOW_SUPPORT = 'UI/SHOW_SUPPORT';
const SHOW_SALESFORCE_MODAL = 'UI/SHOW_SALESFORCE_MODAL';

export { SHOW_SUPPORT, SHOW_SALESFORCE_MODAL };
